var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Col',{staticClass:"flex-align-start error-container flex-1 flex-justify-center"},[_c('Row',{staticClass:"title-text one-row text-align-left"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('Row',{staticClass:"description-text one-row text-align-left"},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }